export const getFileType = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    switch (ext) {
        case 'txt':
        case 'md':
        case 'docx':
        case 'pdf': return ext;
        default: return 'unknown';
    }
};

export const isBinaryFormat = (fileType) => ['docx', 'pdf'].includes(fileType);